export type GridSettings = {
  isEnabled: boolean
  /**
   * Size of each square unit of the grid (in pixels)
   */
  size: number
  /**
   * Every X square units, the grid line will be thicker. This is the X value.
   */
  thickLineStep: number
}

/**
 * Note: All fields are optional in the type as but it seems
 * that all fields are always present in the data. Leaving everything
 * as optional to be safe since the code already handles the case where the fields
 * are missing and it could be for legacy reasons (old inspector data json files with
 * incomplete data maybe?).
 */
export type LayoutSettings = {
  isEnabled: boolean
  totalWidth: number
  horizontalOffset: number
  // Columns
  numberOfColumns: number
  guttersOutside: boolean
  gutterWidth: number
  columnWidth: number
  drawVertical: boolean
  // Rows
  gutterHeight: number
  rowHeightMultiplication: number
  drawHorizontal: boolean
  drawHorizontalLines: boolean
  numberOfRows: number
}

export type ArtboardPreset = {
  name: string
  width: number
  height: number
}

export interface LayerCorners {
  /**
   * Corner type/style
   */
  type: 'rounded' | 'smooth' | 'angled' | 'inside square' | 'inside arc'
  /**
   * Array of radius value, for each corner of the shape. Clockwise from top left
   */
  radius: number[]
}

export interface LayerAppearance {
  opacity: number
  blendMode: string
}

export interface ExportFormat {
  fileFormat: 'PNG' | 'JPG' | 'TIFF' | 'WEBP' | 'PDF' | 'EPS' | 'SVG'
  scale: number
  absoluteSize: number
  // Taken from Sketch
  // https://github.com/sketch-hq/Sketch/blob/605f73c551e7389da2932c7bfe431f247dd4fecf/Modules/SketchModel/Source/MSUserVisibleScaleType.h
  visibleScaleType: VisibleScaleType
}

export enum VisibleScaleType {
  scale = 0,
  width = 1,
  height = 2,
}
